// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../../../../../../../web-hosted/node_modules/css-loader/index.js??ref--1-1!../../../../../../../../../web-hosted/node_modules/postcss-loader/lib/index.js??postcss!./PieceItem.css");
if(typeof content === 'string') content = [[module.id, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = require("!../../../../../../../../../web-hosted/node_modules/style-loader/lib/addStyles.js")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(module.hot) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../../../web-hosted/node_modules/css-loader/index.js??ref--1-1!../../../../../../../../../web-hosted/node_modules/postcss-loader/lib/index.js??postcss!./PieceItem.css", function() {
			var newContent = require("!!../../../../../../../../../web-hosted/node_modules/css-loader/index.js??ref--1-1!../../../../../../../../../web-hosted/node_modules/postcss-loader/lib/index.js??postcss!./PieceItem.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}


//////////////////
// WEBPACK FOOTER
// ../shared-components/src/containers/Mainpage/containers/SingleTaskPage/CollectionView/PiecesView/PieceItem/PieceItem.css
// module id = 707
// module chunks = 0